import { render, staticRenderFns } from "./Storico.vue?vue&type=template&id=5125783a&"
import script from "./Storico.vue?vue&type=script&lang=js&"
export * from "./Storico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports